/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Next_StepInputs */

const en_next_step = /** @type {(inputs: Next_StepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next Step`)
};

const es_next_step = /** @type {(inputs: Next_StepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siguiente Paso`)
};

const fr_next_step = /** @type {(inputs: Next_StepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Étape Suivante`)
};

const de_next_step = /** @type {(inputs: Next_StepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nächster Schritt`)
};

const ja_next_step = /** @type {(inputs: Next_StepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`次のステップ`)
};

const zh_next_step = /** @type {(inputs: Next_StepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下一步`)
};

const ar_next_step = /** @type {(inputs: Next_StepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الخطوة التالية`)
};

const id_next_step = /** @type {(inputs: Next_StepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Langkah Selanjutnya`)
};

const it_next_step = /** @type {(inputs: Next_StepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prossimo Passo`)
};

const ru_next_step = /** @type {(inputs: Next_StepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Следующий Шаг`)
};

const pt_next_step = /** @type {(inputs: Next_StepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próximo Passo`)
};

const ko_next_step = /** @type {(inputs: Next_StepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`다음 단계`)
};

/**
* | output |
* | --- |
* | "Next Step" |
*
* @param {Next_StepInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const next_step = /** @type {((inputs?: Next_StepInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Next_StepInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_next_step(inputs)
	if (locale === "es") return es_next_step(inputs)
	if (locale === "fr") return fr_next_step(inputs)
	if (locale === "de") return de_next_step(inputs)
	if (locale === "ja") return ja_next_step(inputs)
	if (locale === "zh") return zh_next_step(inputs)
	if (locale === "ar") return ar_next_step(inputs)
	if (locale === "id") return id_next_step(inputs)
	if (locale === "it") return it_next_step(inputs)
	if (locale === "ru") return ru_next_step(inputs)
	if (locale === "pt") return pt_next_step(inputs)
	return ko_next_step(inputs)
});